// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"f19dfb3d","104":"4c8c7705","109":"f8559af9","163":"32477dd6","178":"4fdb122e","202":"b4743745","453":"d88cdbc0","455":"0672e1a1","474":"b0d6af39","484":"5f8ff3a5","487":"86c77dcc","498":"87e86aaf","977":"4c479c4e"}[chunkId] + ".chunk.js";
};